export const PAGE_BLOCK_SPACING = {
  base: 64,
  md: 96,
};

export const MIGRATION_PATHS: Record<string, string> = {
  "migration-hubbix": "EBP Hubbix",
  "migration-boby": "Boby",
  "migration-cegid-business": "Cegid Business",
};
